module.exports = __webpack_public_path__ + "static/img/welcome_title.09446d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome_title.png
// module id = /cIv
// module chunks = 1